<template>
    <v-row dense class="mx-0">
        <v-col cols="12" sm="6" lg="3" :class="setClass(0)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-text class="pa-0">
                        <div class="pa-4">Task</div>
                        <div class="flex-column">
                            <span class="display-4 margin-auto info--text font-weight-thin">{{ model.todo }}</span>
                            <span class="margin-auto text-uppercase font-weight-light pb-4">Da fare</span>
                        </div>
                        <v-divider></v-divider>
                        <div class="pa-4">
                            <span class="font-weight-light">Archiviati oggi: <span class="font-weight-medium">{{ model.archived_today }}</span></span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>
        <v-col cols="12" sm="6" lg="3" :class="setClass(1)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-text class="pa-0">
                        <div class="pa-4">Task</div>
                        <div class="flex-column">
                            <span class="display-4 margin-auto error--text font-weight-thin">{{ model.expired }}</span>
                            <span class="margin-auto text-uppercase font-weight-light pb-4">scaduti</span>
                        </div>
                        <v-divider></v-divider>
                        <div class="pa-4">
                            <span class="font-weight-light">Scaduti ieri: <span class="font-weight-medium">{{ model.expired_yesterday }}</span></span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>
        <v-col cols="12" sm="6" lg="3" :class="setClass(2)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-text class="pa-0">
                        <div class="pa-4">Task</div>
                        <div class="flex-column">
                            <span class="display-4 margin-auto primary--text font-weight-thin">{{ model.archived }}</span>
                            <span class="margin-auto text-uppercase font-weight-light pb-4">Archiviati</span>
                        </div>
                        <v-divider></v-divider>
                        <div class="pa-4">
                            <span class="font-weight-light">Archiviati ieri: <span class="font-weight-medium">{{ model.archived_yesterday }}</span></span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>
        <v-col cols="12" sm="6" lg="3" :class="setClass(3)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-text class="pa-0">
                        <div class="pa-4">Checklist</div>
                        <div class="flex-column">
                            <span class="display-4 margin-auto success--text font-weight-thin">{{ checklistsDone }}</span>
                            <span class="margin-auto text-uppercase font-weight-light pb-4">da fare</span>
                        </div>
                        <v-divider></v-divider>
                        <div class="pa-4">
                            <span class="font-weight-light">Completate: <span class="font-weight-medium">{{ model.checklist_items_completed }}</span></span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>
    </v-row>
</template>

<script>
	export default {
        name: 'project-kpi',     
		props: {
            id: Number,            
		},
		data() {
            return {
                model: {}
			}
        },
        
		computed: {
            checklistsDone() {
                return this.model.checklist_items ? this.model.checklist_items - this.model.checklist_items_completed : 0
            }
                      
        },

        methods: {

            setClass(i) {
                if(this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-2'
                    } else if(i == 3) {
                        return 'pa-0 pl-2'
                    } else {
                        return 'pa-0 pr-2 pl-2'
                    }
                }
                if(this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md){
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-2'
                    } else if(i == 2) {
                        return 'pa-0 pl-0 pr-2 pt-4'
                    } else if(i == 3) {
                        return 'pa-0 pl-2 pr-0 pt-4'
                    } else {
                        return 'pa-0 pl-2 pr-0'
                    }                    
                }
                if(this.$vuetify.breakpoint.xs) {
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-0'
                    }
                    return 'pa-0 pl-0 pr-0 pt-4'
                }
            },

            initialize() {
                this.axios.get('project-kpi/' + this.id).then(response => {
                    // get body data
                    this.model = response.data.data
                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })
            },
        },

        mounted() {
            this.$eventBusUtility.$on('updatedTaskboard', () => {
                this.initialize()
            })
        },

        created() {
            this.initialize()
        },

        beforeDestroy() {
			this.$eventBusUtility.$off('updatedTaskboard')
		},

	}
</script>

